<!-- 综合评价 -->
<template>
  <div>
    <el-image class="policyType5-banner" :src="require('@/assets/images/policy/policyType5-banner.png')"></el-image>
    <div class="policyType5-tips">
      综合评价招生是指高校招生录取时，以综合素质为主，综合考量考生高考成绩、高校考核结论、高中学业水平测试成绩、综合索质评价以及高校自身培养特色要求等多个维度的内容，对入选考生进行考核，综合评价，择优录取。
    </div>
    <div class="policyType5-process">
      <div class="">
        <div style="text-align: center;">
          <el-image class="policyType5-titleImage" :src="require('@/assets/images/policy/policyType5-title.png')"></el-image>
          <br>
          <el-image class="policyType5-processImage" :src="require('@/assets/images/policy/policyType5-process.png')"></el-image>
        </div>
      </div>
      <div class="policyType4Plan-title">
        <i class="el-icon-star-on"></i>
        <span style="margin: 0 12px;">综合评价院校在陕招生汇总</span>
        <i class="el-icon-star-on"></i>
      </div>
      <div class="school">
        <div v-for="item in schoolList" class="school-item">
          <img class="school-image" :src="item.iconUrl">
          <div style="flex-shrink: 0;">
            <div class="school-name">{{ item.name }}</div>
            <a v-if="item.hrefUrl" @click="goExternalLink(item.hrefUrl)" href="javascript:void(0);" class="school-link">招生网址</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request"

export default {
  data() {
    return {
      schoolList: []
    }
  },
  mounted() {
    this.getSchoolList()
  },
  methods: {
    goExternalLink(url) {
      window.open(url);
    },
    getSchoolList() {
      request({
        method: 'get',
        url: '/articleInfo/school',
        params: {
          type: 5,
        }
      }).then(res => {
        if (res.code !== 0) return
        this.schoolList = res.data
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.policyType5-banner {
  margin-top 6px
  vertical-align top
}
.policyType5-tips {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  margin: 10px 11px;
}
.policyType5-processImage {
  width: 983px;
  height: 137px;
  vertical-align: top;
  margin: 28px 0 40px 0;
}
.policyType5-titleImage {
  width: 619px;
  height: 19px;
}

.policyType5-process {
  background: none;
  padding: 20px 0;
  background: #E4F3FF;
  border-radius: 8px;
}


.policyType4Plan-title {
  text-align center
  font-weight: 600;
  font-size: 16px;
  color: #061E69;
  line-height: 16px;
  padding: 16px 0
}


.school {
  padding: 0 30px 0 38px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  .school-item {
    display: flex;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 16px 20px;
    width: 228px;
    height: 80px;
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .school-image {
    width: 48px;
    height: 48px;
    vertical-align: top;
    margin-right: 16px;

  }
  .school-name {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    min-height: 28px;
    line-height: 14px;

    word-break: break-all;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .school-link {
    display: inline-flex;
    background: #50ABFF;
    border-radius: 2px;
    padding: 4px 6px;
    line-height: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
  }
}
</style>
